
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl, FormArray, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { debounceTime, delay, filter, map, startWith, takeUntil, tap } from 'rxjs/operators';
import { ClientService, RoleModel } from '../client.service';
import { EventEmitterService } from 'src/app/shared/services/event-emitter.service';
import { Router } from '@angular/router';
import { selectService } from 'src/app/shared/models/dropdown-demo-data';

@Component({
    selector: 'app-client-edit',
    templateUrl: './client-edit.component.html',
    styleUrls: ['./client-edit.component.less'],
    standalone: false
})
export class ClientEditComponent {
  clientCountry = this.selectService.selectList;
  filteredClientCountry = this.selectService.selectList$;
  searching = false;
  onDestroy = new Subject<void>();
  myForm: FormGroup;
  gsaMode: 'view' | 'edit' = 'view';
  gsaIndex: number;
  gsaCol: any[] = [
    { id: 'name', name: 'Name' },
    { id: 'emailId', name: "Email id" },
    { id: 'contactNumber', name: "Contact Number" },
    { id: 'role', name: "Role" },
    { id: "$$edit", name: "$$edit" }
  ];
  gsaColumns: string[] = this.gsaCol.map(col => col.id);
  gsaDataSource = this.service.gsaList$;

  documentMode: 'view' | 'edit' = 'view';
  documentIndex: Number;
  documentCol: any[] = [
    { id: 'documentCode', name: 'Document Code' },
    { id: 'documentName', name: "Document Name" },
    { id: 'uploadDocument', name: "Upload Document" },
    { id: "$$edit", name: "$$edit" }
  ];
  documentColumns: string[] = this.documentCol.map(col => col.id);
  documentDataSource = this.service.documentList$;

  separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredRole: Observable<RoleModel[]>;
  allRole = this.service.roleList$;

  @ViewChild('roleInput') roleInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  constructor(private service: ClientService, public router: Router, public event: EventEmitterService, public selectService: selectService, public fb: FormBuilder) {
  }
  ngOnInit() {
    this.reactiveForm();
    this.selectFill();
  }
  reactiveForm() {
    this.myForm = this.fb.group({
      clientCountryCtrl: [null],
      clientCountryFilteringCtrl: [null],
      gsaControls: FormArray,
      documentControls: FormArray,
      roleControl: [null],
    })
    this.filteredRole = this.myForm.controls["roleControl"].valueChanges.pipe(startWith(''),
      map(value => this.service.roleList)
    );
    this.controlGsa();
    this.controlDocument();
  }
  editGsa(index: number) {
    this.gsaIndex = index;
    this.gsaMode = 'edit';
    return false;
  }
  removeGsa(index: number) {
    this.service.removeGsa(index);
    this.controlGsa();
  }
  updateGsa(index: number) {
    if (this.gsaMode == 'edit') {
      this.gsaMode = 'view';
      this.gsaIndex = 0;
      let gsaValueList = Object.keys(this.service.gsaList$.value[index]);
      for (let prop in gsaValueList) {
        const control = this.getControlGsa(index, gsaValueList[prop]);
        if (control != null) {
          if (control.valid) {
            this.service.updateGsa(index, gsaValueList[prop], control.value);
          }
          if (control.invalid) {
            this.gsaMode = 'edit';
            this.gsaIndex = index + 1;
            break;
          }
        }
      }
    }
  }
  newGsa(eventKey, index: number) {
    if (eventKey.key == "Tab") {
      let status = 0;
      let gsaValueList = Object.keys(this.service.gsaList$.value[index]);
      for (let prop in gsaValueList) {
        const control = this.getControlGsa(index, gsaValueList[prop]);
        if (control != null) {
          if (control.invalid) {
            status = 1;
          }
        }
      }
      if (status == 0) {
        for (let prop in gsaValueList) {
          const control = this.getControlGsa(index, gsaValueList[prop]);
          if (control != null) {
            if (control.valid) {
              this.service.updateGsa(index, gsaValueList[prop], control.value);
            }
          }
        }
        this.service.addRowGsa(index + 1)
        this.controlGsa();
      }
    }
  }
  getControlGsa(index: number, fieldName: string) {
    var arrayControlGsa = this.myForm.get('gsaControls') as FormArray;
    return arrayControlGsa.at(index).get(fieldName) as FormControl;
  }
  getControlDocument(index, fieldName) {
    var arrayControlDocument = this.myForm.get('documentControls') as FormArray;
    return arrayControlDocument.at(index).get(fieldName) as FormControl;
  }
  controlGsa() {
    const togroups = this.service.gsaList$.value.map(entity => {
      return new FormGroup({
        position: new FormControl(entity.position),
        name: new FormControl(entity.name, Validators.required),
        emailId: new FormControl(entity.email, Validators.required),
        contactNumber: new FormControl(entity.contactNo),
        role: new FormControl(entity.role),
      }, { updateOn: "blur" });
    });
    this.myForm.controls.gsaControls = new FormArray(togroups);
  }
  controlDocument() {
    const togroups = this.service.documentList$.value.map(entity => {
      return new FormGroup({
        position: new FormControl(entity.position, Validators.required),
        documentName: new FormControl(entity.documentName, Validators.required),
        uploadDocument: new FormControl(entity.uploadDocument),
        documentCode: new FormControl(entity.documentCode, Validators.required),
      }, { updateOn: "blur" });
    });
    this.myForm.controls.documentControls = new FormArray(togroups);
  }
  editDocument(index: number) {
    this.documentIndex = index;
    this.documentMode = 'edit';
    return false;
  }
  newDocument(eventKey, index: number) {
    if (eventKey.key == "Tab") {
      let status = 0;
      let documentValueList = Object.keys(this.service.documentList$.value[index]);
      for (let prop in documentValueList) {
        const control = this.getControlDocument(index, documentValueList[prop]);
        if (control != null) {
          if (control.invalid) {
            status = 1;
          }
        }
      }
      if (status == 0) {
        for (let prop in documentValueList) {
          const control = this.getControlDocument(index, documentValueList[prop]);
          if (control != null) {
            if (control.valid) {
              this.service.updateDocument(index, documentValueList[prop], control.value);
            }
          }
        }
        this.service.addDocument(index + 1)
        this.controlDocument();
      }
    }
  }
  removeDocument(index: number) {
    this.service.removeDocument(index);
    this.controlDocument();
  }
  updateDocument(index: number) {
    if (this.documentMode == 'edit') {
      this.documentMode = 'view';
      this.documentIndex = 0;
      let documentValueList = Object.keys(this.service.documentList$.value[index]);
      for (let prop in documentValueList) {
        const control = this.getControlDocument(index, documentValueList[prop]);
        if (control != null) {
          if (control.valid) {
            this.service.updateDocument(index, documentValueList[prop], control.value);
          }
          if (control.invalid) {
            this.documentMode = 'edit';
            this.documentIndex = index + 1;
            break;
          }
        }
      }
    }
  }

  removeRole(gsaIndex: number, roleIndex: number): void {
    this.service.removeRole(gsaIndex, roleIndex);
    this.controlGsa();
  }

  addRole(event: MatAutocompleteSelectedEvent, roleIndex: number): void {
    this.service.addNewRole(roleIndex, event.option.viewValue)
  }
  onCancel() {
    this.router.navigate(['masters/operational/client']);
  }
  onSave() {
    this.router.navigate(['masters/operational/client']);
  }
  selectFill() {
    this.myForm.controls.clientCountryFilteringCtrl.valueChanges
      .pipe(
        filter(search => !!search),
        tap(() => this.searching = true),
        takeUntil(this.onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.clientCountry) {
            return [];
          }
          return this.clientCountry.filter(country => country.name.toLowerCase().indexOf(search) > -1);
        }),
        delay(500)
      )
      .subscribe(filteredClient => {
        this.searching = false;
        this.filteredClientCountry.next(filteredClient);
      },
        error => { this.searching = false; });
  }
  ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  }
}








